import { useState } from "react";
import Navbar from "@/components/zeblan/Navbar";
import Hero from "@/components/zeblan/Hero";
import OurStory from "@/components/zeblan/OurStory";
import WhyZeblan from "@/components/zeblan/WhyZeblan";
import CoreValues from "@/components/zeblan/CoreValues";
import Services from "@/components/zeblan/Services";
import HowWeWork from "@/components/zeblan/HowWeWork";
import Aftercare from "@/components/zeblan/Aftercare";
import UseCases from "@/components/zeblan/UseCases";
import WontDo from "@/components/zeblan/WontDo";
import Pricing from "@/components/zeblan/Pricing";
import Contact from "@/components/zeblan/Contact";
import Footer from "@/components/zeblan/Footer";
import LeadModal from "@/components/zeblan/LeadModal";

export default function Landing() {
  const [modal, setModal] = useState({ open: false, type: "contact" });
  const openLead = (type) => setModal({ open: true, type });
  const closeLead = () => setModal((m) => ({ ...m, open: false }));

  return (
    <main className="bg-white text-navy" data-testid="landing-page">
      <Navbar onOpenLead={openLead} />
      <Hero onOpenLead={openLead} />
      <OurStory />
      <WhyZeblan onOpenLead={openLead} />
      <CoreValues />
      <Services />
      <HowWeWork />
      <Aftercare />
      <UseCases />
      <WontDo />
      <Pricing onOpenLead={openLead} />
      <Contact onOpenLead={openLead} />
      <Footer onOpenLead={openLead} />
      <LeadModal open={modal.open} type={modal.type} onClose={closeLead} />
    </main>
  );
}
